import React from "react";

export default ({sortColumn, column, reverse}) => {
    if(sortColumn == column){
   	 return <span className={`fas fa-angle-${reverse === 'desc'?'down':'up'} m-l-5 m-r-5 display-inline`}></span>  
    }
    
    return null;
}
